export const MAP_LOCATION = {
    duration: 500,
    center: [34.759933, 55.307863],
    zoom: 5.4
}

export const MAP_CAMERA = { tilt: 0 }

export const enum ZoomDirection {
    Increase = 'increase',
    Decrease = 'decrease'
}

export const DARK_MAP_CUSTOMIZATION = [
    {
        tags: {
            any: ['water']
        },
        elements: ['label'],
        stylers: [
            {
                opacity: 0
            }
        ]
    },
    {
        tags: {
            any: ['landscape', 'land', 'landcover', 'urban_area', 'national_park', 'terrain']
        },

        elements: 'geometry',
        stylers: [
            {
                color: '#343B7D'
            }
        ]
    },
    {
        tags: {
            any: ['transit']
        },
        elements: ['geometry', 'label'],
        stylers: [
            {
                opacyty: 0
            }
        ]
    },

    {
        tags: {
            any: ['admin', 'country', 'locality', 'district', 'address']
        },
        elements: 'label.text.fill',
        stylers: [
            {
                color: '#CACDE7'
            }
        ]
    },
    {
        tags: {
            any: ['admin', 'country', 'locality', 'district', 'address']
        },
        elements: 'label.text.outline',
        stylers: [
            {
                color: '#20244C'
            }
        ]
    },
    {
        tags: {
            any: ['admin']
        },
        elements: 'geometry',
        stylers: [
            {
                color: '#343B7D'
            }
        ]
    },
    {
        tags: {
            any: ['road', 'water']
        },
        elements: 'geometry',
        stylers: [
            {
                color: '#192376'
            }
        ]
    },

    {
        tags: {
            any: ['poi', 'transit']
        },
        elements: ['geometry', 'label'],
        stylers: [
            {
                opacity: 0
            }
        ]
    },
    {
        tags: {
            any: ['road']
        },
        elements: 'label.icon',
        stylers: [
            {
                opacity: 0
            }
        ]
    }
]

export const LIGHT_MAP_CUSTOMIZATION = [
    {
        tags: {
            any: ['water']
        },
        elements: ['label'],
        stylers: [
            {
                opacity: 0
            }
        ]
    },
    {
        tags: {
            any: ['landscape', 'land', 'landcover', 'urban_area', 'national_park', 'terrain']
        },

        elements: 'geometry',
        stylers: [
            {
                color: '#E7E9F8'
            }
        ]
    },
    {
        tags: {
            any: ['transit']
        },
        elements: ['geometry', 'label'],
        stylers: [
            {
                opacyty: 0
            }
        ]
    },

    {
        tags: {
            any: ['admin', 'country', 'locality', 'district', 'address']
        },
        elements: 'label.text.fill',
        stylers: [
            {
                color: '#212D6F'
            }
        ]
    },

    {
        tags: {
            any: ['admin']
        },
        elements: 'geometry',
        stylers: [
            {
                color: '#E7E9F8'
            }
        ]
    },
    {
        tags: {
            any: ['road', 'water']
        },
        elements: 'geometry',
        stylers: [
            {
                color: '#FCFDFE'
            }
        ]
    },

    {
        tags: {
            any: ['poi', 'transit']
        },
        elements: ['geometry', 'label'],
        stylers: [
            {
                opacity: 0
            }
        ]
    },
    {
        tags: {
            any: ['road']
        },
        elements: 'label.icon',
        stylers: [
            {
                opacity: 0
            }
        ]
    }
]
